module.exports = __webpack_public_path__ + "static/media/7x7BadOptimized.34745b64.webp";